export default __webpack_public_path__ + "static/media/backgroundmodal.fe02f573.png";